<template>
    <div>
        <div class="row align-items-center" style="border-bottom: 2px #f0f0f0 solid;">
            <div class="col" style="padding: .5rem 1rem; font-size: 19px;">
                {{ question.label }}
            </div>
            <div class="col" style="padding: .5rem 0rem; max-width: 600px;">
                <div class="check-options">
                    <ul>
                        <li @click="setOutcome(outcomes.OUTCOME_PASSED)" :class="[{'selected': internalAnswer.outcome === outcomes.OUTCOME_PASSED}]">
                            <div class="check-area passed">
                                <svg viewBox='7.7 12.2 32.55 23.5' xmlns='http://www.w3.org/2000/svg'><path d='M18.9 35.7 7.7 24.5l2.15-2.15 9.05 9.05 19.2-19.2 2.15 2.15Z' fill='white'/></svg>
                            </div>
                            Passed
                        </li>
                        <li @click="setOutcome(outcomes.OUTCOME_ADVISORY)" :class="[{'selected': internalAnswer.outcome === outcomes.OUTCOME_ADVISORY}]">
                            <div class="check-area advisory">
                                <svg viewBox='7.7 12.2 32.55 23.5' xmlns='http://www.w3.org/2000/svg'><path d='M18.9 35.7 7.7 24.5l2.15-2.15 9.05 9.05 19.2-19.2 2.15 2.15Z' fill='white'/></svg>
                            </div>
                            Advisory
                        </li>
                        <li @click="setOutcome(outcomes.OUTCOME_FAILED)" :class="[{'selected': internalAnswer.outcome === outcomes.OUTCOME_FAILED}]">
                            <div class="check-area failed">
                                <svg viewBox='7.7 12.2 32.55 23.5' xmlns='http://www.w3.org/2000/svg'><path d='M18.9 35.7 7.7 24.5l2.15-2.15 9.05 9.05 19.2-19.2 2.15 2.15Z' fill='white'/></svg>
                            </div>
                            Failed
                        </li>
                        <li @click="setOutcome(outcomes.OUTCOME_SKIPPED)" style="max-width: 65px;" :class="[{'selected': internalAnswer.outcome === outcomes.OUTCOME_SKIPPED}]">
                            <div class="check-area skipped">
                                <svg viewBox='7.7 12.2 32.55 23.5' xmlns='http://www.w3.org/2000/svg'><path d='M18.9 35.7 7.7 24.5l2.15-2.15 9.05 9.05 19.2-19.2 2.15 2.15Z' fill='white'/></svg>
                            </div>
                            Skip
                        </li>
                    </ul>
                </div>
            </div>
            <div v-if="mayRequireRemediation(internalAnswer)" class="col-12" style="padding: .5rem 0em">
                <textarea
                    v-model="internalAnswer.comments"
                    placeholder="Notes (Why did the item fail?)"
                    style="width: 100%; padding: .5rem; border-color: #999;"
                    :disabled="isSaving"
                    @change="updated"
                ></textarea>
            </div>
        </div>
    </div>
</template>

<script>
import {AnswerOutcomes, AnswerOutcomesList} from "../../classes/Api/Inspection";
import {cloneDeep} from "lodash";

export default {
    props: {
        question: {
            type: Object,
            required: true
        },
        answer: {
            type: Object,
            required: true,
        },
        isSaving: {
            type: Boolean,
            default() { return false }
        }
    },
    created() {
        this.setAnswer(this.answer)
    },
    watch: {
      answer: {
          handler(n) {
              this.setAnswer(n)
          },
          deep: true
      }
    },
    data() {
        return {
            outcomes: AnswerOutcomes,
            internalAnswer: {},
        }
    },
    methods: {
        setOutcome(outcome) {
            if (!this.isSaving) {
                this.internalAnswer.outcome = outcome

                this.updated()
            }
        },
        setAnswer(answer) {
            this.internalAnswer = cloneDeep(answer)
        },
        updated() {
            this.$emit('input', this.internalAnswer)
        },
        mayRequireRemediation(answer) {
            return AnswerOutcomes.OUTCOME_FAILED === answer.outcome ||
                AnswerOutcomes.OUTCOME_ADVISORY === answer.outcome
        }
    }
}
</script>

<style lang="scss" scoped>
    .check-options {
        ul {
            margin: 0;
            padding: 0;
            list-style: none;
            text-align: center;
            display: flex;

            li {
                flex-grow: 1;
                margin: 0 1rem;
                position: relative;
                .check-area svg { width: 30px; visibility: hidden; }

                &.selected {
                    .check-area svg { visibility: visible; }
                }
            }
        }
    }

    .check-area {
        padding: 1rem;
        border-radius: 3px;
        margin: .5rem 0;
        cursor: pointer;

        &.passed { background: #65d06d; &:hover { background: darken(#65d06d, 10%); } }
        &.advisory { background: #fae070; &:hover { background: darken(#fae070, 10%); } }
        &.failed { background: #ea5155; &:hover { background: darken(#ea5155, 10%); } }
        &.skipped { background: #ccc; &:hover { background: darken(#ccc, 10%); } }
    }
</style>